import { isStorageQuotaError } from "@/home/home-idb";

const DB_NAME = "mind-survival-gm";
const STORE = "kv";
const DB_VERSION = 1;
const CATALOG_KEY = "monster-catalog/v1";
const PART_CATALOG_KEY = "part-catalog/v1";
const SHOP_CATALOG_KEY = "shop-catalog/v1";
const HOME_RAIL_MENU_LAYOUT_KEY = "home-rail-menu-layout/v1";

let dbPromise: Promise<IDBDatabase> | null = null;

function openDb(): Promise<IDBDatabase> {
  if (dbPromise) return dbPromise;
  dbPromise = new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);
    request.onupgradeneeded = () => {
      const db = request.result;
      if (!db.objectStoreNames.contains(STORE)) {
        db.createObjectStore(STORE);
      }
    };
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error ?? new Error("เปิด IndexedDB ไม่สำเร็จ"));
  });
  return dbPromise;
}

function idbGet<T>(key: string): Promise<T | null> {
  return openDb().then(
    (db) =>
      new Promise((resolve, reject) => {
        const tx = db.transaction(STORE, "readonly");
        const req = tx.objectStore(STORE).get(key);
        req.onsuccess = () => resolve((req.result as T | undefined) ?? null);
        req.onerror = () => reject(req.error ?? new Error("อ่าน IndexedDB ไม่สำเร็จ"));
      }),
  );
}

function idbSet(key: string, value: unknown): Promise<void> {
  return openDb().then(
    (db) =>
      new Promise((resolve, reject) => {
        const tx = db.transaction(STORE, "readwrite");
        tx.oncomplete = () => resolve();
        tx.onerror = () => reject(tx.error ?? new Error("เขียน IndexedDB ไม่สำเร็จ"));
        tx.objectStore(STORE).put(value, key);
      }),
  );
}

export async function loadGmMonsterCatalogFromIdb(): Promise<unknown[] | null> {
  try {
    const raw = await idbGet<unknown>(CATALOG_KEY);
    if (!raw) return null;
    if (!Array.isArray(raw)) return null;
    return raw;
  } catch {
    return null;
  }
}

export async function saveGmMonsterCatalogToIdb(items: unknown[]): Promise<void> {
  await idbSet(CATALOG_KEY, items);
}

export async function loadGmPartCatalogFromIdb(): Promise<unknown[] | null> {
  try {
    const raw = await idbGet<unknown>(PART_CATALOG_KEY);
    if (!raw) return null;
    if (!Array.isArray(raw)) return null;
    return raw;
  } catch {
    return null;
  }
}

export async function saveGmPartCatalogToIdb(items: unknown[]): Promise<void> {
  await idbSet(PART_CATALOG_KEY, items);
}

export async function loadGmShopCatalogFromIdb(): Promise<unknown[] | null> {
  try {
    const raw = await idbGet<unknown>(SHOP_CATALOG_KEY);
    if (!raw) return null;
    if (!Array.isArray(raw)) return null;
    return raw;
  } catch {
    return null;
  }
}

export async function saveGmShopCatalogToIdb(items: unknown[]): Promise<void> {
  await idbSet(SHOP_CATALOG_KEY, items);
}

export async function loadHomeRailMenuLayoutFromIdb(): Promise<unknown | null> {
  try {
    return await idbGet<unknown>(HOME_RAIL_MENU_LAYOUT_KEY);
  } catch {
    return null;
  }
}

export async function saveHomeRailMenuLayoutToIdb(layout: unknown): Promise<void> {
  await idbSet(HOME_RAIL_MENU_LAYOUT_KEY, layout);
}

export { isStorageQuotaError };
